import { h, defineComponent } from 'vue';
import { t } from '@/ui/i18n/i18n';
import {
  QuestionOptions
} from '@/_legacy/components/ConductInspection/ConductInspectionItem/ConductInspectionItemQuestion/QuestionOptions';
import { Button } from '@/ui/components/Button';

interface ConductInspectionItemQuestionGeolocationProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  item: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  entities: any;
}

export const ConductInspectionItemQuestionGeolocation = defineComponent<ConductInspectionItemQuestionGeolocationProps>({
  name: 'ConductInspectionItemQuestionGeolocation',
  props: ['item', 'entities'],
  setup(props, context) {
    return function render() {
      return h('div', [
        h(Button, [t('form.set-location')]),
        h('div', { class: 'text-sm mt-2 mb-2' }, [`*${t('form.geolocation-warning')}`]),
        h(QuestionOptions, {
          props: {
            ...props
          },
          // @ts-ignore
          on: {
            ...context.listeners,
          }
        }),
      ]);
    };
  },
});
